<template>
  <v-card>
    <v-card-title>
      Usuario
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row class="container-form-nuevo-usuario">
          <v-col cols="12">
            <v-text-field
              :error-messages="nombreErrors"
              @input="$v.objetoUsuario.Nombre.$touch()"
              @blur="$v.objetoUsuario.Nombre.$touch()"
              autofocus
              v-model.trim="objetoUsuario.Nombre"
              @keypress="ValidaEntrada($event, SoloLetras)"
              @keyup="objetoUsuario.Nombre = Capitaliza(objetoUsuario.Nombre)"
              @keyup.enter="insertarUsuario()"
              autocomplete="new"
              label="Nombre"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :error-messages="apellidoPaternoErrors"
              @input="$v.objetoUsuario.Apellido_P.$touch()"
              @blur="$v.objetoUsuario.Apellido_P.$touch()"
              v-model.trim="objetoUsuario.Apellido_P"
              @keypress="ValidaEntrada($event, SoloLetras)"
              @keyup="objetoUsuario.Apellido_P = Capitaliza(objetoUsuario.Apellido_P)"
              @keyup.enter="insertarUsuario()"
              autocomplete="new"
              label="Apellido Paterno"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :error-messages="apellidoMaternoErrors"
              @input="$v.objetoUsuario.Apellido_M.$touch()"
              @blur="$v.objetoUsuario.Apellido_M.$touch()"
              v-model.trim="objetoUsuario.Apellido_M"
              @keypress="ValidaEntrada($event, SoloLetras)"
              @keyup="objetoUsuario.Apellido_M = Capitaliza(objetoUsuario.Apellido_M)"
              @keyup.enter="insertarUsuario()"
              autocomplete="new"
              label="Apellido Materno"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :error-messages="emailErrors"
              @input="$v.objetoUsuario.Email.$touch()"
              @blur="$v.objetoUsuario.Email.$touch()"
              v-model.trim="objetoUsuario.Email"
              @keyup.enter="insertarUsuario()"
              autocomplete="new"
              label="Email"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              :items="sucursalesList"
              item-text="NOMBRE"
              item-value="ID"
              v-model="objetoUsuario.Sucursal"
              label="Sucursal"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :error-messages="usuarioErrors"
              @input="$v.objetoUsuario.Usuario.$touch()"
              @blur="$v.objetoUsuario.Usuario.$touch()"
              v-model.trim="objetoUsuario.Usuario"
              @keyup.enter="insertarUsuario()"
              autocomplete="new"
              label="Usuario"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword1 ? 'text' : 'password'"
              @click:append="showPassword1 = !showPassword1"
              :error-messages="passwordErrors"
              @input="$v.objetoUsuario.Password.$touch()"
              @blur="$v.objetoUsuario.Password.$touch()"
              v-model="objetoUsuario.Password"
              @keyup.enter="insertarUsuario()"
              autocomplete="new-password"
              label="Contraseña"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="objetoUsuario.Rol"
              :items="rolesList"
              item-text="DESCRIPCION"
              item-value="ROL"
              label="Rol"
            >
            </v-select>
          </v-col>
          <v-col cols="6">
            <v-switch
              inset
              v-model="switchEstado"
              @change="estadoCheck()"
              :label="objetoUsuario.Estado == 0 ? 'Estado: Deshabilitado' : 'Estado: Habilitado'"
            ></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" @click="cierraDialogo()" text>Cancelar</v-btn>
      <v-btn color="blue darken-1" @click="insertarUsuario()" text>Aceptar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf, email } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import { ValidaEntradaTeclado, CapitalizaPalabra } from "../Utils/Utils";

const nombreRegex = /^([a-zA-ZÁÉÍÓÚÑáéíóúñ ]{1,25})$/;
const apellidoPRegex = /^([a-zA-ZÁÉÍÓÚÑáéíóúñ]{1,25})$/;
const apellidoMRegex = /^([a-zA-ZÁÉÍÓÚÑáéíóúñ]{1,25})$/;
const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
const usuarioRegex = /^([a-zA-Z0-9]{4,40})$/;
const passwordRegex = /^([a-zA-Z0-9@%$&*]{8,50})$/;

export default {
  mixins: [validationMixin],
  validations: {
    objetoUsuario: {
      Nombre: {
        required,
        nombreValida(Nombre) {
          return nombreRegex.test(Nombre);
        }
      },
      Apellido_P: {
        required,
        apellidoPValida(Apellido_P) {
          return apellidoPRegex.test(Apellido_P);
        }
      },
      Apellido_M: {
        apellidoMValida(Apellido_M) {
          return apellidoMRegex.test(Apellido_M);
        }
      },
      Email: {
        required,
        email
      },
      Usuario: {
        required,
        usuarioValida(Usuario) {
          return usuarioRegex.test(Usuario);
        }
      },
      Password: {
        required: requiredIf(function(form) {
          return this.voyAInsertar;
        }),
        passwordValida(Password) {
          if (this.objetoUsuario.Password.length == 0) {
            return true;
          } else {
            return passwordRegex.test(Password);
          }
        }
      }
    }
  },
  data: () => ({
    showPassword1: false,
    voyAInsertar: true,
    SoloLetras: /^[a-zA-ZáéíóúÁÉÍÓÚÑñäÄöÖüÜ ]+$/,
    itemsRoles: [
      { rol: "ADMIN", ide: 1 },
      { rol: "EMPLEADO", ide: 2 }
    ],
    itemsEstados: [
      { estado: "ACTIVO", ide: 1 },
      { estado: "INACTIVO", ide: 0 }
    ],
    switchEstado: true,
    objetoUsuario: {
      Nombre: "",
      Apellido_P: "",
      Apellido_M: "",
      Email: "",
      Usuario: "",
      Password: "",
      Rol: "1",
      Estado: 1,
      Sucursal: "1"
    }
  }),
  props: {
    usuarioPasadoModal: Object
  },
  computed: {
    ...mapState("usuarios", {
      rolesList: state => state.rolesUsuarios
    }),
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    nombreErrors() {
      const errors = [];
      if (!this.$v.objetoUsuario.Nombre.$dirty) return errors;
      !this.$v.objetoUsuario.Nombre.required && errors.push("El campo nombre es requerido.");
      !this.$v.objetoUsuario.Nombre.nombreValida &&
        errors.push("El campo nombre no tiene el formato correcto.");
      return errors;
    },
    apellidoPaternoErrors() {
      const errors = [];
      if (!this.$v.objetoUsuario.Apellido_P.$dirty) return errors;
      !this.$v.objetoUsuario.Apellido_P.required &&
        errors.push("El campo apellido paterno es requerido.");
      !this.$v.objetoUsuario.Apellido_P.apellidoPValida &&
        errors.push("El campo apellido paterno no tiene el formato correcto.");
      return errors;
    },
    apellidoMaternoErrors() {
      const errors = [];
      if (!this.$v.objetoUsuario.Apellido_M.$dirty) return errors;
      // !this.$v.objetoUsuario.Apellido_M.required &&
      //   errors.push("El campo apellido materno es requerido.");
      !this.$v.objetoUsuario.Apellido_M.apellidoMValida &&
        errors.push("El campo apellido materno no tiene el formato correcto.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.objetoUsuario.Email.$dirty) return errors;
      !this.$v.objetoUsuario.Email.required && errors.push("El campo email es requerido.");
      !this.$v.objetoUsuario.Email.email &&
        errors.push("El campo debe ser un correo electrónico válido.");
      return errors;
    },
    usuarioErrors() {
      const errors = [];
      if (!this.$v.objetoUsuario.Usuario.$dirty) return errors;
      !this.$v.objetoUsuario.Usuario.required && errors.push("El campo usuario es requerido.");
      !this.$v.objetoUsuario.Usuario.usuarioValida &&
        errors.push("El campo usuario no tiene el formato correcto.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.objetoUsuario.Password.$dirty) return errors;
      !this.$v.objetoUsuario.Password.required && errors.push("El campo contraseña es requerido.");
      !this.$v.objetoUsuario.Password.passwordValida &&
        errors.push("El campo contraseña no tiene el formato correcto.");
      return errors;
    }
  },
  async mounted() {
    const res = await this.obtenRoles();
    const res2 = await this.obtenSucursales();

    if (res) {
      if (this.usuarioPasadoModal.ID) {
        (this.voyAInsertar = false), (this.objetoUsuario.Nombre = this.usuarioPasadoModal.NOMBRE);
        this.objetoUsuario.Id = this.usuarioPasadoModal.ID;
        this.objetoUsuario.Apellido_P = this.usuarioPasadoModal.APELLIDO_P;
        this.objetoUsuario.Apellido_M = this.usuarioPasadoModal.APELLIDO_M;
        this.objetoUsuario.Email = this.usuarioPasadoModal.EMAIL;
        this.objetoUsuario.Usuario = this.usuarioPasadoModal.USUARIO;
        if (this.usuarioPasadoModal.ESTADO === "Activo") {
          this.switchEstado = true;
          this.objetoUsuario.Estado = 1;
        } else {
          this.switchEstado = false;
          this.objetoUsuario.Estado = 0;
        }
        const indiceDeListaRoles = this.rolesList.findIndex(
          element => element.DESCRIPCION == this.usuarioPasadoModal.ROL
        );
        const indiceDeListaSucursales = this.sucursalesList.findIndex(
          element => element.NOMBRE == this.usuarioPasadoModal.SUCURSAL
        );
        this.objetoUsuario.Rol = this.rolesList[indiceDeListaRoles].ROL;
        this.objetoUsuario.Sucursal = this.sucursalesList[indiceDeListaSucursales].ID;
      }
    }
  },
  methods: {
    ...mapActions("usuarios", ["getRoles"]),
    ...mapActions("sucursales", ["getSucursales"]),
    estadoCheck() {
      if (this.switchEstado == true) {
        this.objetoUsuario.Estado = 1;
      } else if (this.switchEstado == false) {
        this.objetoUsuario.Estado = 0;
      }
    },
    async obtenSucursales() {
      // TODO revisar esto
      // if (this.sucursalesList.length === 0) {
      const res = await this.getSucursales();
      if (res) {
        return true;
      }
      return false;
      // }
      // return true;
    },
    async obtenRoles() {
      if (this.rolesList.length === 0) {
        const res = await this.getRoles();
        if (res) {
          return true;
        }
        return false;
      }
      return true;
    },
    insertarUsuario() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (this.objetoUsuario.Password.length == 0) {
          delete this.objetoUsuario.Password;
        }
        this.voyAInsertar
          ? this.$emit("insertarUsuario", this.objetoUsuario)
          : this.$emit("editarUsuario", this.objetoUsuario);
      }
    },
    cierraDialogo() {
      this.$emit("cierraDialogo");
    },
    Capitaliza(texto) {
      return CapitalizaPalabra(texto);
    },
    ValidaEntrada(event, expresion) {
      return ValidaEntradaTeclado(event, expresion);
    }
  }
};
</script>

<style lang="css" scoped>
.container-form-nuevo-usuario > div {
  margin-top: -10px;
  margin-bottom: -10px;
}
</style>
